module.exports = __webpack_public_path__ + "bdd4ea6a8de2c219d85a5549f8b506b6.MP3";